var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "choose-products-page" },
    [
      _vm.isAmend
        ? _c("div", { staticClass: "choose-order-amend-title" }, [
            _vm._v("\n    修改订单中\n  ")
          ])
        : _vm._e(),
      _c("StoreMenu", {
        attrs: {
          vipVolumeKey: _vm.vipVolumeKey,
          isVipVolume: _vm.isVipVolume,
          isAddCart: _vm.isAddCart
        },
        on: {
          initAdditional: _vm.initAdditional,
          getProductGroup: _vm.getCombo,
          getProductCombination: _vm.getProductCombination
        }
      }),
      _c(
        "div",
        { staticClass: "choose-products-page-right" },
        [
          _c("Cart", {
            attrs: { isAddCart: _vm.isAddCart, deliveryFee: _vm.deliveryFee },
            on: {
              initAdditional: _vm.initAdditional,
              getProductGroup: _vm.initProductCombo,
              saveAdditional: _vm.saveAdditional,
              initProductGroup: _vm.initProductCombo,
              saveCombo: _vm.saveCombo
            }
          }),
          _c("Discounts", {
            attrs: {
              isDelivery: _vm.isDelivery,
              deliveryFee: _vm.deliveryFee,
              isAmend: _vm.isAmend,
              isAddCart: _vm.isAddCart
            }
          }),
          _c("more-info", {
            attrs: {
              vipVolumeKey: _vm.vipVolumeKey,
              isVipVolume: _vm.isVipVolume,
              isDelivery: _vm.isDelivery,
              deliveryFee: _vm.deliveryFee,
              cokeKey: _vm.cokeKey,
              isAmend: _vm.isAmend,
              isColaCupConversionListeningSet:
                _vm.isColaCupConversionListeningSet,
              isAddCart: _vm.isAddCart
            },
            on: { update: _vm.isUpdate, updatePayType: _vm.updatePayType }
          })
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { width: "570px" },
          model: {
            value: _vm.additional.visible,
            callback: function($$v) {
              _vm.$set(_vm.additional, "visible", $$v)
            },
            expression: "additional.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.additional.title))
          ]),
          _vm.additional.visible
            ? _c(
                "div",
                { staticClass: "additional" },
                [
                  _c(
                    "div",
                    { staticClass: "additional-list" },
                    [
                      _vm._l(_vm.additional.list, function(item, key) {
                        return _c(
                          "div",
                          { key: key, staticClass: "additional-item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "am-inline-block am-pos-relative"
                              },
                              [
                                _c(
                                  "Button",
                                  {
                                    class: { active: item.active },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.checkProductCopies(
                                          _vm.additional,
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("第" + _vm._s(key + 1) + "份餐")
                                    ])
                                  ]
                                ),
                                _vm.additional.list.length > 1
                                  ? _c("div", {
                                      staticClass:
                                        "additional-item-close am-icon-close",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeProductCopies(
                                            _vm.additional,
                                            item,
                                            key
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm.additional.single
                              ? [
                                  _c("InputQuantity", {
                                    staticClass: "am-margin-left-sm",
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      size: "small",
                                      min: 0,
                                      disabled: item.disabled,
                                      max: item.maxNum
                                    },
                                    on: { "on-change": _vm.updateAdditional },
                                    model: {
                                      value: item.num,
                                      callback: function($$v) {
                                        _vm.$set(item, "num", $$v)
                                      },
                                      expression: "item.num"
                                    }
                                  })
                                ]
                              : [
                                  _c("InputQuantity", {
                                    staticClass: "am-margin-left-sm",
                                    staticStyle: { width: "50px" },
                                    attrs: {
                                      size: "small",
                                      prepend: "",
                                      append: "",
                                      max: item.maxNum
                                    },
                                    on: {
                                      "on-blur": function($event) {
                                        return _vm.calculateProductMax(
                                          _vm.additional
                                        )
                                      },
                                      "on-change": _vm.updateAdditional
                                    },
                                    model: {
                                      value: item.num,
                                      callback: function($$v) {
                                        _vm.$set(item, "num", $$v)
                                      },
                                      expression: "item.num"
                                    }
                                  })
                                ]
                          ],
                          2
                        )
                      }),
                      !_vm.additional.single
                        ? _c("div", { staticClass: "additional-add" }, [
                            _c("div", {
                              staticClass: "additional-add-plus am-icon-plus",
                              on: {
                                click: function($event) {
                                  return _vm.addProductCopies(_vm.additional)
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._l(_vm.additional.list, function(item, index) {
                    return item.active
                      ? [
                          _c("Additional", {
                            key: index,
                            attrs: {
                              value: item,
                              category: _vm.additional.category
                            },
                            on: { updateAdditional: _vm.updateAdditional }
                          })
                        ]
                      : _vm._e()
                  }),
                  _c(
                    "div",
                    { staticClass: "additional-total" },
                    [
                      _vm._l(_vm.additional.list, function(item, key) {
                        return [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.active,
                                  expression: "item.active"
                                }
                              ],
                              key: key
                            },
                            [
                              _c("span", [_vm._v("本份搭配总价:")]),
                              !_vm.combo.visible
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "prefix-price-unit am-color-price am-padding-horizontal-xs"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.currency) +
                                          _vm._s(item.totalCurrentProductPrice)
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "prefix-price-unit am-color-price am-padding-horizontal-xs"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("computePrice")(
                                            item.totalCurrentProductPrice -
                                              (item.price || 0) *
                                                (item.num || 0)
                                          )
                                        )
                                      )
                                    ]
                                  ),
                              _c("span", { staticClass: "am-color-price" }, [
                                _c("span", [_vm._v("(")]),
                                !_vm.combo.visible
                                  ? _c(
                                      "span",
                                      { staticClass: "prefix-price-unit" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.currency) +
                                            _vm._s(
                                              _vm._f("computePrice")(
                                                item.pricing
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "prefix-price-unit" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.currency) +
                                            _vm._s(
                                              _vm._f("computePrice")(
                                                item.pricing - (item.price || 0)
                                              )
                                            )
                                        )
                                      ]
                                    ),
                                _c("span", [
                                  _vm._v("X" + _vm._s(item.num) + "份)")
                                ])
                              ])
                            ]
                          )
                        ]
                      }),
                      _c("span", { staticClass: "am-padding-left-sm" }, [
                        _c("span", [_vm._v("全部餐品总价:")]),
                        !_vm.combo.visible
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "prefix-price-unit am-color-price am-padding-left-xs"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.currency) +
                                    _vm._s(_vm.additional.totalProductPrice)
                                )
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "prefix-price-unit am-color-price am-padding-left-xs"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.currency) +
                                    _vm._s(
                                      _vm._f("formatPrice")(
                                        _vm.additional.totalProductPrice -
                                          (_vm.additional.productPrice || 0) *
                                            (_vm.additional.total || 0)
                                      )
                                    )
                                )
                              ]
                            )
                      ])
                    ],
                    2
                  )
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "am-text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                { staticClass: "am-inline-block" },
                [
                  _vm.additional.single
                    ? [
                        _c(
                          "Button",
                          {
                            staticClass: "am-btn-custom-default",
                            nativeOn: {
                              click: function($event) {
                                return _vm.saveOtherAdditional.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ]
                    : [
                        _c(
                          "Button",
                          {
                            staticClass: "am-btn-custom-default",
                            nativeOn: {
                              click: function($event) {
                                return _vm.saveAdditional()
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ]
                ],
                2
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-custom-cancel am-margin-left-20",
                  nativeOn: {
                    click: function($event) {
                      _vm.additional.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          model: {
            value: _vm.combo.visible,
            callback: function($$v) {
              _vm.$set(_vm.combo, "visible", $$v)
            },
            expression: "combo.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.combo.title))
          ]),
          _c(
            "div",
            { staticClass: "combo" },
            [
              _c(
                "div",
                { staticClass: "combo-list" },
                [
                  _vm._l(_vm.combo.list, function(item, key) {
                    return _c(
                      "div",
                      {
                        key: key,
                        staticClass:
                          "am-margin-right-sm am-margin-bottom-sm combo-item"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "am-inline-block" },
                          [
                            _c(
                              "Button",
                              {
                                class: { active: item.active },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.checkProductCopies(
                                      _vm.combo,
                                      item
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v("第" + _vm._s(key + 1) + "份餐")
                                ])
                              ]
                            ),
                            _vm.combo.list.length > 1
                              ? _c("div", {
                                  staticClass: "combo-item-close am-icon-close",
                                  on: {
                                    click: function($event) {
                                      return _vm.removeProductCopies(
                                        _vm.combo,
                                        item,
                                        key
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("InputQuantity", {
                          staticClass: "am-margin-left-sm",
                          staticStyle: { width: "50px" },
                          attrs: {
                            size: "small",
                            prepend: "",
                            append: "",
                            max: item.maxNum
                          },
                          on: {
                            "on-change": _vm.updateCombo,
                            "on-blur": function($event) {
                              return _vm.calculateProductMax(_vm.combo)
                            }
                          },
                          model: {
                            value: item.num,
                            callback: function($$v) {
                              _vm.$set(item, "num", $$v)
                            },
                            expression: "item.num"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c("div", { staticClass: "combo-add" }, [
                    _c("div", {
                      staticClass: "additional-add-plus am-icon-plus",
                      on: {
                        click: function($event) {
                          return _vm.addProductCopies(_vm.combo)
                        }
                      }
                    })
                  ])
                ],
                2
              ),
              _vm._l(_vm.combo.list, function(item, key) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.active,
                        expression: "item.active"
                      }
                    ],
                    key: key,
                    staticClass: "combo-pane am-scroll"
                  },
                  [
                    _vm._l(item.mainList, function(main, key) {
                      return _c(
                        "div",
                        { key: key, staticClass: "combo-main" },
                        [
                          _c(
                            "div",
                            { staticClass: "combo-title am-text-center" },
                            [_vm._v(_vm._s(main.title))]
                          ),
                          _c(
                            "div",
                            { staticClass: "combo-content" },
                            [
                              !main.hide
                                ? _c("div", { staticClass: "combo-table" }, [
                                    _c("div", { staticClass: "combo-tr" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "combo-td combo-tr-title"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(main.title) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "combo-td" },
                                        [
                                          _c(
                                            "RadioGroup",
                                            {
                                              on: {
                                                "on-change": function($event) {
                                                  return _vm.updateCombo(item)
                                                }
                                              },
                                              model: {
                                                value: main.checkValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    main,
                                                    "checkValue",
                                                    $$v
                                                  )
                                                },
                                                expression: "main.checkValue"
                                              }
                                            },
                                            _vm._l(main.cells, function(
                                              product,
                                              key
                                            ) {
                                              return _c("Radio", {
                                                key: key,
                                                staticClass:
                                                  "am-margin-top-10 am-margin-right-20",
                                                attrs: {
                                                  label: key,
                                                  custom: "",
                                                  disabled: product.disabled
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var currentValue =
                                                          ref.currentValue
                                                        return _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "am-button-custom",
                                                            class: {
                                                              active: currentValue,
                                                              disabled:
                                                                product.disabled
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "am-inline-block"
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      product.name
                                                                    ) + " "
                                                                  )
                                                                ]),
                                                                product.hasStock
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "am-padding-left-sm"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "(库存：" +
                                                                            _vm._s(
                                                                              product.stockNum
                                                                            ) +
                                                                            ")"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "product.warnText"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        product.warnText
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            product.property &&
                                                            currentValue
                                                              ? [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "am-inline-block combo-additional-button",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.initComboAdditional(
                                                                            product
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "特殊要求"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      product.num
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "prefix-price-unit"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.currency
                                                                                  ) +
                                                                                  _vm._s(
                                                                                    product.totalProductPrice
                                                                                  ) +
                                                                                  "\n                              "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              main.mainGroups
                                ? [
                                    _c("ComboGroup", {
                                      attrs: {
                                        list: main.mainGroups,
                                        combo: item
                                      },
                                      on: {
                                        updateCombo: _vm.updateCombo,
                                        initComboAdditional:
                                          _vm.initComboAdditional
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    }),
                    item.auxiliaryItem
                      ? [
                          _c(
                            "div",
                            { staticClass: "combo-title am-text-center" },
                            [_vm._v("副食区")]
                          ),
                          _c(
                            "div",
                            { staticClass: "combo-content" },
                            [
                              _c("ComboGroup", {
                                attrs: {
                                  list: item.auxiliaryItem.items,
                                  combo: item
                                },
                                on: {
                                  updateCombo: _vm.updateCombo,
                                  initComboAdditional: _vm.initComboAdditional
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              _c(
                "div",
                { staticClass: "combo-total" },
                [
                  _vm._l(_vm.combo.list, function(item, key) {
                    return [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.active,
                              expression: "item.active"
                            }
                          ],
                          key: key
                        },
                        [
                          _c("span", [_vm._v("本份搭配总价:")]),
                          _c(
                            "span",
                            {
                              staticClass:
                                "prefix-price-unit am-color-price am-padding-horizontal-xs"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  _vm._s(item.totalCurrentProductPrice)
                              )
                            ]
                          ),
                          _c("span", { staticClass: "am-color-price" }, [
                            _c("span", [_vm._v("(")]),
                            _c("span", { staticClass: "prefix-price-unit" }, [
                              _vm._v(
                                _vm._s(_vm.currency) + _vm._s(item.pricing)
                              )
                            ]),
                            _c("span", [_vm._v("X" + _vm._s(item.num) + "份)")])
                          ])
                        ]
                      )
                    ]
                  }),
                  _c("span", { staticClass: "am-padding-left-sm" }, [
                    _c("span", [_vm._v("全部餐品总价:")]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "prefix-price-unit am-color-price am-padding-left-xs"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.currency) +
                            _vm._s(_vm.combo.totalProductPrice)
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "am-text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                { staticClass: "am-inline-block" },
                [
                  _c(
                    "Button",
                    {
                      staticClass: "am-btn-custom-default",
                      nativeOn: {
                        click: function($event) {
                          return _vm.saveCombo()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-custom-cancel am-margin-left-20",
                  nativeOn: {
                    click: function($event) {
                      _vm.combo.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "550px" },
          model: {
            value: _vm.combination.visible,
            callback: function($$v) {
              _vm.$set(_vm.combination, "visible", $$v)
            },
            expression: "combination.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.combination.title))
          ]),
          _vm.combination.visible
            ? _c("div", { staticClass: "combination" }, [
                _c(
                  "div",
                  { staticClass: "combination-wrap" },
                  [
                    _vm._l(_vm.combination.list, function(project, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "combination-item" },
                        [
                          _c("div", { staticClass: "combination-title" }, [
                            _vm._v(_vm._s(project.name))
                          ]),
                          _c(
                            "RadioGroup",
                            {
                              staticClass: "am-padding-horizontal-xs",
                              on: { "on-change": _vm.combinationProjectChange },
                              model: {
                                value: project.checkValue,
                                callback: function($$v) {
                                  _vm.$set(project, "checkValue", $$v)
                                },
                                expression: "project.checkValue"
                              }
                            },
                            _vm._l(project.items, function(item) {
                              return _c("Radio", {
                                key: item.uid,
                                staticClass:
                                  "am-margin-top-sm am-margin-right-20",
                                attrs: { custom: "", label: item.uid },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var currentValue = ref.currentValue
                                        return _c(
                                          "div",
                                          {
                                            staticClass: "am-button-custom",
                                            class: { active: currentValue }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(item.name) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _vm.combination.product && _vm.combination.product.uid
                      ? [
                          _c("div", { staticClass: "combination-total" }, [
                            _c("span", [_vm._v("本地搭配总价:")]),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "prefix-price-unit am-color-price am-padding-horizontal-xs"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.currency) +
                                    _vm._s(
                                      (
                                        _vm.combination.price *
                                        _vm.combination.product.num
                                      ).toFixed(2)
                                    )
                                )
                              ]
                            ),
                            _c("span", [
                              _c("span", [_vm._v("(")]),
                              _c("span", { staticClass: "prefix-price-unit" }, [
                                _vm._v(_vm._s(_vm.combination.price))
                              ]),
                              _c("span", [
                                _vm._v(
                                  "X" +
                                    _vm._s(_vm.combination.product.num) +
                                    "份)"
                                )
                              ])
                            ]),
                            _c("span", { staticClass: "am-padding-left-sm" }, [
                              _c("span", [_vm._v("全部餐品总价:")]),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "prefix-price-unit am-color-price am-padding-left-xs"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.currency) +
                                      _vm._s(
                                        (
                                          _vm.combination.price *
                                          _vm.combination.product.num
                                        ).toFixed(2)
                                      )
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "am-text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "am-cf" }, [
                _vm.combination.product
                  ? _c("div", { staticClass: "combination-cart am-fl" }, [
                      _c("div", { staticClass: "am-fl" }, [
                        _c(
                          "div",
                          { staticClass: "combination-cart-product-name" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "am-button-custom",
                                class: {
                                  disabled: _vm.combination.product.warnText
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "am-inline-block am-pos-relative"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "am-padding-right-sm" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.combination.product.name)
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.combination.product.warnText,
                                            expression:
                                              "combination.product.warnText"
                                          }
                                        ],
                                        staticClass:
                                          "am-padding-right-sm am-color-price"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.combination.product.warnText
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm.combination.product.property
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "am-inline-block combination-additional-button",
                                          on: {
                                            click: function($event) {
                                              return _vm.initCombinationAdditional(
                                                _vm.combination.product
                                              )
                                            }
                                          }
                                        },
                                        [_c("span", [_vm._v("特殊要求")])]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "am-padding-left-sm am-fl" },
                        [
                          _c("InputQuantity", {
                            staticStyle: { width: "90px" },
                            attrs: {
                              min: 1,
                              max: _vm.combination.maxNum,
                              disabled: _vm.combination.product.disabled
                            },
                            model: {
                              value: _vm.combination.product.num,
                              callback: function($$v) {
                                _vm.$set(_vm.combination.product, "num", $$v)
                              },
                              expression: "combination.product.num"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "am-text-left am-color-price" }, [
                      _vm._v("\n          餐品不存在,请重新选择组合\n        ")
                    ]),
                _c(
                  "div",
                  { staticClass: "am-fr" },
                  [
                    _c(
                      "div",
                      { staticClass: "am-inline-block" },
                      [
                        _vm.combination.product
                          ? _c(
                              "Button",
                              {
                                staticClass: "am-btn-custom-default",
                                attrs: {
                                  disabled: _vm.combination.product.disabled
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.saveCombination.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("确定\n            ")]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "Button",
                      {
                        staticClass: "am-btn-custom-cancel am-margin-left-20",
                        nativeOn: {
                          click: function($event) {
                            _vm.combination.visible = false
                          }
                        }
                      },
                      [_vm._v("取消\n          ")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e3093ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e3093ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pagesCache/order/order.vue
// module id = 7Rqk
// module chunks = 0